export interface StorageHealth {
  supported: boolean;
  persisted: boolean;
  usage?: number;
  quota?: number;
  usageRatio?: number;
}

export async function inspectStorageHealth(): Promise<StorageHealth> {
  if (typeof navigator === 'undefined' || !navigator.storage) return { supported: false, persisted: false };
  const [persisted, estimate] = await Promise.all([
    navigator.storage.persisted?.() ?? Promise.resolve(false),
    navigator.storage.estimate?.() ?? Promise.resolve({}),
  ]);
  const usage = estimate.usage;
  const quota = estimate.quota;
  return {
    supported: true,
    persisted,
    usage,
    quota,
    usageRatio: usage !== undefined && quota ? usage / quota : undefined,
  };
}

export async function requestPersistentStorage(): Promise<boolean> {
  if (typeof navigator === 'undefined' || !navigator.storage?.persist) return false;
  if (await navigator.storage.persisted()) return true;
  return navigator.storage.persist();
}
